import React from "react";
import ContactUs from "../components/forms/ContactUs/contactus";
import NavbarShared from "../components/ui/NavbarShared/NavbarShared";
function Contact() {
  return (
    <>
      <NavbarShared/>
      <ContactUs />
    </>
  );
}

export default Contact;
